import { useEffect, useRef, useState } from "react";
import { Box, Dialog, IconButton, Zoom } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { useDispatch, useSelector } from "react-redux";
import { closeJewellerInstalaxmiPopup } from "../../redux/LuckyDrawPopup/luckyDrawPopupSlice";

const JewellerInstalaxmiPopupDialog = () => {
  const dispatch = useDispatch();
  const { jewellerPopup, jewellerPopupOpen } = useSelector(
    (state) => state.luckyDrawPopup || {},
  );
  const files = jewellerPopup?.files || [];
  const [index, setIndex] = useState(0);
  const touchStartX = useRef(null);

  useEffect(() => {
    setIndex(0);
  }, [jewellerPopup?._id]);

  const close = () => dispatch(closeJewellerInstalaxmiPopup());
  const hasMany = files.length > 1;
  const imageUrl = files[index] || files[0] || "";

  const showPrev = () =>
    setIndex((value) => (value - 1 + files.length) % files.length);
  const showNext = () => setIndex((value) => (value + 1) % files.length);

  return (
    <Dialog
      open={!!jewellerPopupOpen && files.length > 0}
      onClose={close}
      slots={{ transition: Zoom }}
      maxWidth={false}
      aria-label="Popup"
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(18, 8, 32, 0.72)",
            backdropFilter: "blur(8px)",
          },
        },
        paper: {
          sx: {
            m: 2,
            width: { xs: "94vw", md: "86vw" },
            maxWidth: 1100,
            borderRadius: "18px",
            overflow: "hidden",
            backgroundColor: "#fff",
            boxShadow: "0 28px 80px rgba(20, 10, 40, 0.45)",
          },
        },
      }}
    >
      <Box sx={{ position: "relative", lineHeight: 0, backgroundColor: "#fff" }}>
        <IconButton
          onClick={close}
          aria-label="Close"
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            zIndex: 2,
            width: 40,
            height: 40,
            color: "#1a1028",
            backgroundColor: "rgba(255,255,255,0.94)",
            boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
            "&:hover": { backgroundColor: "#fff" },
          }}
        >
          <CloseRoundedIcon />
        </IconButton>

        <Box
          onTouchStart={(event) => {
            touchStartX.current = event.changedTouches[0]?.clientX ?? null;
          }}
          onTouchEnd={(event) => {
            if (!hasMany || touchStartX.current == null) return;
            const endX = event.changedTouches[0]?.clientX ?? touchStartX.current;
            const delta = endX - touchStartX.current;
            if (delta > 40) showPrev();
            if (delta < -40) showNext();
            touchStartX.current = null;
          }}
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fff",
            minHeight: 320,
          }}
        >
          {hasMany && (
            <IconButton
              onClick={showPrev}
              aria-label="Previous image"
              sx={{
                position: "absolute",
                left: 10,
                zIndex: 1,
                backgroundColor: "rgba(255,255,255,0.92)",
                color: "#4c1d95",
                boxShadow: "0 6px 16px rgba(76, 29, 149, 0.18)",
                "&:hover": { backgroundColor: "#fff" },
              }}
            >
              <ChevronLeftRoundedIcon />
            </IconButton>
          )}

          {imageUrl && (
            <Box
              component="img"
              src={imageUrl}
              alt="Lucky draw"
              sx={{
                width: "100%",
                height: "auto",
                maxHeight: "86vh",
                objectFit: "contain",
                display: "block",
              }}
            />
          )}

          {hasMany && (
            <IconButton
              onClick={showNext}
              aria-label="Next image"
              sx={{
                position: "absolute",
                right: 10,
                zIndex: 1,
                backgroundColor: "rgba(255,255,255,0.92)",
                color: "#4c1d95",
                boxShadow: "0 6px 16px rgba(76, 29, 149, 0.18)",
                "&:hover": { backgroundColor: "#fff" },
              }}
            >
              <ChevronRightRoundedIcon />
            </IconButton>
          )}
        </Box>

        {hasMany && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 0.8,
              py: 1.5,
              lineHeight: 1,
            }}
          >
            {files.map((file, dotIndex) => (
              <Box
                key={file}
                component="button"
                type="button"
                aria-label={`Show image ${dotIndex + 1}`}
                onClick={() => setIndex(dotIndex)}
                sx={{
                  width: dotIndex === index ? 22 : 8,
                  height: 8,
                  p: 0,
                  border: 0,
                  borderRadius: 999,
                  cursor: "pointer",
                  backgroundColor:
                    dotIndex === index ? "#752ADA" : "rgba(117, 42, 218, 0.28)",
                  transition: "width 0.2s ease, background-color 0.2s ease",
                }}
              />
            ))}
          </Box>
        )}
      </Box>
    </Dialog>
  );
};

export default JewellerInstalaxmiPopupDialog;
